import { atom, useAtom } from 'jotai';
const extensionConnectedAtom = atom(false);
export const useExtensionState = () => {
  const [extensionConnected, setExtensionConnected] = useAtom(extensionConnectedAtom);

  return {
    extensionConnected,
    setExtensionConnected,
  };
};
